"use client";

import * as React from "react";
import { Lightbulb, ClipboardList, Star, ArrowDown } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  id: 1,
  title: "ԱՐԲԱՆՅԱԿԱՅԻՆ ՏՎՅԱԼՆԵՐ",
  description: "Բարձր լուծաչափով արբանյակային պատկերների ստացում և վերլուծություն ռազմավարական որոշումների համար:",
  Icon: Lightbulb,
  iconBg: "bg-primary/20",
  iconColor: "text-primary"
}, {
  id: 2,
  title: "ԹՎԱՅԻՆ ՔԱՐՏԵԶԱԳՐՈՒՄ",
  description: "Ճշգրիտ ռելիեֆի և տեղանքի թվային մոդելների (DSM/DTM) ստեղծում ժամանակակից տեխնոլոգիաներով:",
  Icon: ClipboardList,
  iconBg: "bg-primary/20",
  iconColor: "text-primary"
}, {
  id: 3,
  title: "ԳԵՈԴԵԶԻԱԿԱՆ ԼՈՒԾՈՒՄՆԵՐ",
  description: "Մասնագիտացված ֆոտոգրամետրիկ և գեոդեզիական աշխատանքներ՝ ինժեներական բարձր ճշգրտությամբ:",
  Icon: Star,
  iconBg: "bg-primary/20",
  iconColor: "text-primary"
}];
const stats = [{
  value: "17+",
  label: "Գործընկերներ"
}, {
  value: "65+",
  label: "ՀԱՎԱՔԱԿԱՆ ՏԱՐԻՆԵՐԻ ՓՈՐՁ"
}, {
  value: "130TB\xA0",
  label: "ԱՐԲԱՆՅԱԿԱՅԻՆ ՏՎՅԱԼՆԵՐ"
}, {
  value: "50270km²",
  label: "ՏԱՐԵԿԱՆ ՍՊԱՍԱՐԿՎՈՂ ՏԱՐԱԾՔ"
}];
export default function ServicesAndImpact() {
  // Hook for the Services section
  const {
    ref: servicesRef,
    isVisible: isServicesVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });

  // Hook for the Statistics section
  const {
    ref: statsRef,
    isVisible: isStatsVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <>
      {/* SERVICES SECTION */}
      

      {/* STATISTICS SECTION */}
      <section data-section-id="245973" id="orbitalstatistics" className="text-foreground py-32 px-4 md:px-8 overflow-hidden dark bg-muted">
        <h3 className="text-center mb-16 text-primary font-mono uppercase tracking-[0.2em] !text-4xl !font-semibold">
          Ցուցանիշներ
        </h3>
        <div ref={statsRef} className={`max-w-7xl mx-auto transition-all duration-1000 ease-out ${isStatsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-y-16 md:gap-y-0">
            {stats.map((stat, i) => <div key={i} data-index={i} className="relative flex flex-col items-center justify-center text-center px-4">
                <span className="text-[72px] font-bold font-mono leading-none tracking-tighter text-primary">
                  {stat.value}
                </span>
                <span className="text-foreground text-lg mt-4 font-default font-semibold uppercase tracking-widest">
                  {stat.label}
                </span>

                {/* Separators */}
                {i < stats.length - 1 && <>
                    <Separator orientation="horizontal" className="absolute -bottom-8 left-1/2 -translate-x-1/2 w-24 opacity-30 bg-primary md:hidden" />
                    <Separator orientation="vertical" className="absolute right-0 top-1/2 -translate-y-1/2 h-32 opacity-30 bg-primary hidden md:block" />
                  </>}
              </div>)}
          </div>
        </div>
      </section>
    </>;
}